<template>
  <div>
    <base-card :option="cardOption">
      <div slot="cardBody">
        <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
        <!--      操作按钮-->
        <div class="table-operator"></div>
        <!--表格-->
        <div class="table">
          <a-table
            :columns="table.columns"
            :rowKey="(record) => record.id"
            :dataSource="table.data"
            :pagination="pagination"
            :loading="table.loading"
            @change="handleTableChange"
            :scroll="{ x: 1220, y:300}"
          >
            <template slot="actions" slot-scope="text, record">
              <a href="javascript:;" @click="() => handleResult(record)" v-show="record.status === 1">填写结果</a>
              <a-divider type="vertical" v-show="record.status === 1" />
              <a href="javascript:;" @click="() => handleIgnore(record)" v-show="record.status === 1">忽略</a>
              <a-divider type="vertical" v-show="record.status === 1" />
              <a href="javascript:;" @click="() => handleView(record)">查看</a>
            </template>
          </a-table>
        </div>
      </div>
    </base-card>
    <!--各种弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>
    <import-modal ref="importModal" @refreshTable="initTableData"></import-modal>
    <view-modal ref="viewModal" @refreshTable="initTableData"></view-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getUserEvaluateList} from '@/api/assessment'


import editModal from './editModal'
import searchForm from './searchForm'
import baseCard from '@/CrComponents/Card/Card'
import importModal from './importModal'
import viewModal from './viewModal'
export default {
  name: 'assessmentList',
  components: {
    editModal,
    searchForm,
    baseCard,
    importModal,
    viewModal,
  },
  data() {
    return {
      //card相关属性设置
      cardOption: {},
      //搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      searchText: '',
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      table: {
        data: [],
        config: {},
        columns: [
          {
            title: '姓名',
            dataIndex: 'userName',
            width: 60,
          },
          {
            title: '截止考核日期',
            dataIndex: 'deadline',
            width: 80,
          },
          {
            title: '填写日期',
            dataIndex: 'fillInTime',
            width: 80,
          },
          {
            title: '周期类型',
            dataIndex: 'type',
            customRender: (text) => { // 编译后端传来的数据为数字的值
              if (text === 1) return '第一季度'
              if (text === 2) return '半年度'
              if (text === 3) return '第三季度'
              if (text === 4) return '年度'
            },
            width: 80
          },
          {
            title: '直属领导',
            dataIndex: 'headName',
            width: 80,
          },
          {
            title: '考核评分',
            dataIndex: 'score',
            width: 80,
          },
          {
            title: '考核结果',
            dataIndex: 'scoreLevelStr',
            width: 80,
          },
          {
            title: '状态',
            dataIndex: 'status',
            customRender: (text) => {
              if (text === 0) return '已考核'
              if (text === 1) return '待考核'
              if (text === 9) return '考核忽略'
            },
            width: 80
          },
          {
            title: '操作',
            fixed: 'right',
            width: 160,
            align: 'center',
            scopedSlots: {
              customRender: 'actions',
            },
          },
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null,
      },
    }
  },
  mounted() {
    // 页面加载完时，处理获取表格数据的参数
    this.searchModel = { ...this.pagination }
    this.initDictData()
  },
  computed: mapGetters(['assessDept']),
  watch: {
    assessDept() {
      this.initTableData()
    }
  },
  methods: {
    ...mapActions([ // 使用vuex里面定义的方法
      'handleAssessResultList'
    ]),
    // 初始化字典数据
    initDictData () {
      this.handleAssessResultList()
    },
    // 导入
    handleImport() {
      this.$refs.importModal.setModel(this.model)
      this.$refs.importModal.open(true)
    },
    // 筛选条件的查询
    setSearchCondition(searchFormModel) {
      this.searchFormModel = searchFormModel
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...searchFormModel }
      // console.log(888, this.searchModel);
      this.initTableData()
    },
    // 重置
    clearSearch(searchFormModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...this.searchTableModel }
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    initTableData() {
      this.table.loading = true
      this.searchModel.deptId = this.assessDept.id
      getUserEvaluateList(this.searchModel).then(res => {
        if (res.status === 0) {
          this.table.loading = false
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 切换页码等操作
    handleTableChange(pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchModel,
        ...this.pagination,
      }
      this.initTableData()
    },
    // 填写结果
    handleResult(model) {
      this.$refs.editModal.setTitle('填写考核结果')
      this.$refs.editModal.setModel(model) // 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 忽略
    handleIgnore(model) {
      this.$refs.importModal.setTitle('忽略本次考核')
      this.$refs.importModal.setModel(model) // 先设置类型，再打开
      this.$refs.importModal.open(true)
    },
    // 查看详情
    handleView(model) {
      this.$refs.viewModal.setTitle('查看考核结果')
      this.$refs.viewModal.setModel(model) // 先设置类型，再打开
      this.$refs.viewModal.open(true)
    }
  }
}
</script>

<style scoped lang="less">
.listContent {
  .table {
    margin-top: 10px;
  }
}
</style>
